// Whitelist, not an iteration over the payload: latitude/longitude are
// structurally absent from every merchant-bot address block and must stay
// unrenderable even if a future payload starts carrying them.
const ADDRESS_FIELDS = [
  ['recipient_name', 'Name'],
  ['address_line_1', 'Address'],
  ['address_line_2', 'Address 2'],
  ['city', 'City'],
  ['state', 'State'],
  ['zip', 'ZIP'],
  ['country', 'Country'],
  ['delivery_notes', 'Notes']
]

export function addressDisplayFields(address) {
  if (!address) return []
  return ADDRESS_FIELDS.filter(([key]) => address[key]).map(([key, label]) => ({ label, value: address[key] }))
}
